/* app/js/src/components/upload-graphics/upload-graphics.scss */
.cursor-pointer {
  cursor: pointer;
}
.btn-upload,
.input-graphics-file + label {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-upload:focus,
.input-graphics-file + label:focus {
  outline-color: #ffffff;
}
.btn-upload:hover,
.input-graphics-file + label:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.btn-upload,
.input-graphics-file + label.disabled {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
:host {
  display: flex;
  flex-grow: 1;
  flex-basis: 0;
  flex-shrink: 0;
  overflow: hidden;
  overflow-y: scroll;
  background-color: #f1f3f4;
}
.upload-graphics-thumbnail-container {
  height: 100%;
  width: 100%;
  padding-top: 82px;
  padding-left: 205px;
  display: flex;
  flex-direction: row;
}
.upload-graphics-container {
  width: 50%;
  display: flex;
  flex-direction: column;
}
.upload-graphics-header {
  color: #232f3a;
  font-family: TitilliumWeb;
  font-size: 36px;
  font-weight: bold;
}
.graphics-name {
  margin-top: 20px;
}
evrideo-time-editor {
  display: inline-block;
  background-color: white;
}
.graphics-name-label {
  font-family: "Open Sans";
  font-size: 14px;
  color: #7d8fa1;
}
.graphics-name-input {
  font-family: "Open Sans";
  font-size: 12px;
  color: #232f3a;
  padding: 5px;
  margin-left: 15px;
  border: solid 1px #c9cdd6;
  border-radius: 4px;
  opacity: 0.9;
  width: 323px;
  height: 23px;
}
.graphics-description-textarea {
  font-family: "Open Sans";
  font-size: 12px;
  color: #232f3a;
  padding: 5px;
  border: solid 1px #c9cdd6;
  border-radius: 4px;
  opacity: 0.9;
  width: 446px;
  margin-top: 30px;
  height: 100px;
  resize: none;
}
.input-graphics-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.input-graphics-file + label {
  margin-top: 30px;
}
.file-chosen {
  margin-left: 10px;
}
.btn-upload {
  margin-top: 15px;
  width: 62px;
}
.graphics-dropdown {
  margin-left: 15px;
}
.upload-thumbnail-font-container {
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=upload-graphics.css.map */
